import React from "react";

import { Tile } from "./TypeEmblem.styled";

const isSignalsightWordmark = (image) =>
    typeof image === "string" && image.includes("signal-sight");

/** Square icon tile for a source / destination type (logo or initials). */
const TypeEmblem = ({ image, name = "", size = 40 }) => (
    <Tile $size={size} aria-hidden>
        {image ? (
            <img
                src={image}
                alt=""
                className={
                    isSignalsightWordmark(image) ? "emblem-wordmark" : undefined
                }
            />
        ) : (
            <span className="emblem-fallback">
                {name.slice(0, 2).toUpperCase()}
            </span>
        )}
    </Tile>
);

export default TypeEmblem;
